export const pageTitleClasses =
  'text-xl font-semibold tracking-tight text-neutral-900';

export const sectionTitleClasses =
  'text-base font-semibold tracking-tight text-neutral-900';

export const pageHeaderClasses =
  'px-4 sm:px-6 md:px-0 flex items-center justify-between';
